import React from "react";
import { copyToClipboard } from "../../utils/utilsHelpers";
import ReportContent from "../actions/ReportContent";

export default function PostingAdminMenu(props) {
    let {
        posting,
        userSignedIn,
        adminUser,
        viewingSelf,
        token,
        type,
        toggleRegistration,
        leadData={}
    } = props;

    const renderAdminMenu = () => {
        return (
            <div className={'dropdown'}>
                <a className={'dropdown-toggle link-medium px-0 px-sm-2'} data-bs-toggle={'dropdown'} data-bs-target={`#post_admin_${posting.id}`}>
                    <i className={'fas fa-ellipsis-v'}></i>
                </a>
                <div className={'dropdown-menu dropdown-menu-end rounded font-13 py-1 mt-1'} id={`#post_admin_${posting.id}`}>
                    <a
                        href={posting.author.url}
                        className={'dropdown-item border-bottom'}
                    >
                        <i className={'fal fa-user me-2'}></i>
                        Author profile
                    </a>

                    {(viewingSelf || adminUser) && <a
                        href={posting.actions.edit_url}
                        className={'dropdown-item border-bottom'}
                    >
                        <i className={'fal fa-pencil me-2'}></i>
                        Edit
                    </a>}

                    {adminUser &&
                        <>
                            <a href={`${posting.actions.edit_url}?raw=-1`} className={'dropdown-item border-bottom'}>
                                <i className={'fal fa-edit me-2'}></i>
                                Raw edit
                            </a>

                            <a href={posting.actions.seo_url} className={'dropdown-item border-bottom'}>
                                <i className={'fal fa-cog me-2'}></i>
                                SEO
                            </a>

                            <a className={'dropdown-item border-bottom'} onClick={() => { copyToClipboard(posting.actions.cop_url) }}>
                                <i className={'fal fa-link me-2'}></i>
                                COP link
                            </a>
                        </>
                    }
                    {adminUser && posting.actions.token_url &&
                        <a className={'dropdown-item border-bottom'} onClick={() => { copyToClipboard(posting.actions.token_url) }}>
                            <i className={'fal fa-lock me-2'}></i>
                            Token
                        </a>
                    }

                    <div className={'dropdown-item border-bottom'}>
                        <ReportContent
                            item={posting}
                            itemType={type}
                            itemUrl={posting.actions.url}
                            linkClasses={'ms-0 text-gray-dark'}
                            userSignedIn={userSignedIn}
                            toggleRegistration={toggleRegistration}
                            leadData={leadData}
                            token={token} />
                    </div>

                </div>
            </div>
        )
    }

    return (
        <>
            {renderAdminMenu()}
        </>
    )
}